import { sameAddress } from '@/client/confs/app';
import { CurrencyView } from '../currency-view';
import { SwitchBaseToken } from '../switch-base-token';
import { Button } from '../ui/button';
import { WithdrawModel } from './withdraw-model';
import { InteractDepositIcon } from '@/client/assets';
import { useSingerTokenBalance } from '@/client/hooks/use-signed-token-balance';
import { useTheme } from '@/client/hooks/use-theme';
import { useAppSettingStore } from '@/client/store/app-store';
import { useModelStore } from '@/client/store/model-store';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { useTranslation } from 'react-i18next';

export const WalletBalance = () => {
  const { t } = useTranslation();
  const setDepositOpen = useModelStore(state => state.setDepositOpen);
  const baseToken = useAppSettingStore(state => state.baseToken);
  const tokenBalances = useSingerTokenBalance(api);
  const tokenBalance = tokenBalances.data?.find(item => sameAddress(item.baseTokenAddress, baseToken.address));
  const { theme } = useTheme();
  return (
    <div
      style={{ backgroundImage: baseToken.img ? `url(${baseToken.img})` : undefined }}
      className={cn(
        'p-4 rounded-4 border space-y-5 md:space-y-9 flex flex-col min-h-[220px]',
        'transition-all duration-500 bg-cover bg-no-repeat bg-[position:center]'
      )}
    >
      {/* Wallet balance (on-chain) */}
      <div className="space-y-3 flex-1 text-main-foreground">
        <div className="flex items-center justify-between gap-1">
          <h4 className="font-semibold leading-[normal]">{t('wallet-balance', 'Wallet Balance')}</h4>
          <SwitchBaseToken inline />
        </div>
        {/* isPending (not isLoading) + no-data => spinner: a disabled or
            failing on-chain read must never render as a real "0" balance */}
        <CurrencyView
          animated={true}
          showUnit={true}
          className="font-bold text-8 leading-none items-end"
          isLoading={tokenBalances.isPending || !tokenBalance}
          value={tokenBalance?.balance}
          decimal={tokenBalance?.baseTokenDecimals}
          unitClassName="text-xl text-main-foreground/40 leading-[normal]"
        />
      </div>
      {/* action */}
      <div className="flex items-center justify-between space-x-2">
        <Button
          variant={theme == 'dark' ? 'secondary' : 'default'}
          className="p-4 rounded-3 h-13 font-semibold leading-[normal] w-full shadow-none"
          onClick={() => setDepositOpen(true)}
        >
          <InteractDepositIcon className="fill-current" />
          {t('deposit')}
        </Button>
        <WithdrawModel />
      </div>
    </div>
  );
};
